import { useMemo } from 'react'
import { Select } from '../ui/Select'
import { STT_LANGUAGES } from '../../lib/languages'
import { sortLanguageOptions } from '../../lib/languageOptions'
import { useI18n, useT } from '../../i18n/useT'

interface LanguageSelectProps {
  value: string
  onChange: (value: string) => void
  error?: boolean
}

export function LanguageSelect({ value, onChange, error }: LanguageSelectProps) {
  const t = useT()
  const { locale } = useI18n()
  // Language names come from the catalog, so the picker follows the UI
  // language; the values stay the STT codes either way. The ORDER has to
  // follow it too — STT_LANGUAGES is sorted by the English names, and only
  // the first 40 are shown before you type.
  const options = useMemo(
    () =>
      sortLanguageOptions(
        [
          // Empty value = let the service detect the language from the audio
          { value: '', label: t('form.autoDetect') },
          ...STT_LANGUAGES.map((lang) => ({
            value: lang.code,
            label: t(`langName.${lang.code}`),
          })),
        ],
        locale,
      ),
    [t, locale],
  )
  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      placeholder={t('form.autoDetect')}
      searchable
      label={t('form.language')}
      error={error}
    />
  )
}
